<script setup lang="ts">
import { cx } from './cx'

defineProps<{
  title?: string
  hint?: string
  class?: string
}>()
</script>

<template>
  <section :class="cx('panel overflow-hidden', $props.class)">
    <header
      v-if="title || $slots.actions"
      class="flex items-center justify-between gap-3 border-b border-line bg-raised/40 px-4 py-3"
    >
      <span class="flex min-w-0 items-baseline gap-2">
        <h2 class="text-[14px] font-semibold tracking-tight">{{ title }}</h2>
        <span v-if="hint" class="truncate text-[12px] text-dim">{{ hint }}</span>
      </span>
      <div v-if="$slots.actions" class="flex shrink-0 items-center gap-2">
        <slot name="actions" />
      </div>
    </header>
    <slot />
  </section>
</template>
